import { useEffect, useState } from 'react';

const useSuspendChatConnection = (onFocus, isEnabled) => {
	const [tabBlurred, setTabBlurred] = useState(false);

	useEffect(() => {
		if (!isEnabled) return;

		const focusHandler = () => {
			onFocus(() => setTabBlurred(false));
		};

		const blurHandler = () => {
			setTabBlurred(true);
		};

		const visibilityChangeHandler = () => {
			if (document.hidden) {
				blurHandler();
			} else {
				focusHandler();
			}
		};

		visibilityChangeHandler();
		document.addEventListener('visibilitychange', visibilityChangeHandler);
		return () => {
			document.removeEventListener('visibilitychange', visibilityChangeHandler);
		};
	}, [isEnabled]);

	return {tabBlurred};
};

export default useSuspendChatConnection;